import type { User, Withdrawal } from '@library/types/payments';
import { WithdrawalsRow } from '@library/components/withdrawals/WithdrawalsRow';

export interface WithdrawalsRowsProps {
  withdrawals: Withdrawal[];
  user: User;
  onWithdrawalRowClick: (Withdrawal: Withdrawal) => void;
}

export const WithdrawalsRows = ({
  withdrawals,
  user,
  onWithdrawalRowClick
}: WithdrawalsRowsProps) => {
  const rows: Array<JSX.Element> = withdrawals?.map((withdrawal) => {
    return (
      <WithdrawalsRow
        onWithdrawalRowClick={onWithdrawalRowClick}
        key={withdrawal.merchantReferenceId}
        withdrawal={withdrawal}
        user={user}
      />
    );
  });

  return <tbody className="text-2xs xl:text-xs">{rows}</tbody>;
};
